require('dotenv').config();

/* eslint-disable max-len */

export const port = process.env.PORT || 3000;
export const host = process.env.WEBSITE_HOSTNAME || `localhost:${port}`;
export const url = 'http://localhost:3001';
export const socketUrl = process.env.SOCKET_URL || 'http://localhost:4001'
export const socketPort = process.env.SOCKET_PORT || 4001;

export const sitename = 'Your Website Name';

export const locales = ['en-US', 'es', 'it-IT', 'fr-FR', 'pt-PT', 'ar']; // default locale is the first one

export const availableListSettings = [1, 20, 3, 4, 10, 21, 13, 14, 15, 18, 19];

export const coinbaseURL = process.env.COINBASE_URL;

export const fileuploadDir = "./images/upload/"; // Listing Photos Upload Directory

export const homelogouploadDir = './images/logo/'; // Home Logo upload directory

export const banneruploadDir = './images/banner/'; // Home page Banner upload directory

export const profilePhotouploadDir = './images/avatar/'; // User Profile Photos Upload Directory

export const documentuploadDir = './images/document/'; //Document Upload

export const locationuploadDir = './images/popularLocation/'; // Location upload directory

export const homebanneruploadDir = './images/home/'; // Homepage images

export const claimImagesUploadDir = './images/claims/'; // claim images

export const faviconUploadDir = './images/favicon/'; //favicon dir

export const whyHostUploadDir = './images/whyhost/'; // whyHostUploadDir	

export const logouploadDir = './images/logo/'; // Logo upload directory

export const ogImageuploadDir = './images/og-image/'; // OG Image Upload directory

export const analytics = {  // https://analytics.google.com/
  google: { trackingId: 'UA-XXXXX-X' },
};

export const googleMapAPI = '<Your API Key>';

export const googleCaptcha = { sitekey: '<Your Site key>' }; // site key for google recaptcha

export const payment = {

  paypal: {
    returnURL: `${url}${process.env.PAYPAL_RETURN_URL}`,
    cancelURL: `${url}${process.env.PAYPAL_CANCEL_URL}`,
    redirectURL: {
      success: `${url}${process.env.PAYPAL_SUCCESS_REDIRECT_URL}`,
      cancel: `${url}${process.env.PAYPAL_CANCEL_URL}`
    },
    versions: {
      versionOne: '/v1',
      versionTwo: '/v2'
    },
    token_url: '/oauth2/token',
    payment_url: '/checkout/orders',
    capture_url: '/capture',
    payout_url: '/payments/payouts',
    refund: '/refund',
    refund_capture: '/payments/captures/'
  },

  stripe: {
    secretKey: process.env.STRIPE_SECRET, /* From ENV */
    publishableKey: 'pk_test_C5ukBJM7qr5P1F8dY4XKhdyp'
  }

};

export const auth = {
  redirectURL: {
    login: process.env.LOGIN_URL || '/dashboard',
    verification: process.env.LOGIN_URL || '/user/verification',
    userbanned: process.env.USER_BANNED_URL || '/userbanned',
    returnURLDeletedUser: process.env.DELETE_USER_URL || '/userbanned'
  },

  facebook: { // https://developers.facebook.com/ IT IS REMOVED ON THE FUNCTIONING CODE. 
    returnURL: process.env.FACEBOOK_CLIENT_URL || `${url}/login/facebook/return`,
  },

  google: { // https://cloud.google.com/console/project
    returnURL: process.env.GOOGLE_CLIENT_URL || `${url}/login/google/return`,
  }
};

